module.exports = __webpack_public_path__ + "img/icontriangle.f5100058.svg";